import { toFinite } from "lodash";

export function toSEK(v: any) {
  v = toFinite(v);

  return `${v.toLocaleString("sv-SE", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })} kr.`;
}
